import { XMarkIcon } from "@heroicons/react/24/outline";
import { Transition } from "@headlessui/react";
import { useState } from "react";
import { ReactSVG } from "react-svg";
import { PDFViewer } from "@react-pdf/renderer";

const PdfDialog = ({
  open,
  onClose = () => {},
  title = "",
  component = () => {},
}) => {
  const [showViewer, setShowViewer] = useState(true);
  const toggleViewer = () => {
    setShowViewer(false); // Unmount the component
    setTimeout(() => setShowViewer(true), 100); // Remount after a short delay
    onClose();
  };

  return (
    <Transition
      enter="transition duration-300 ease-out"
      enterFrom="transform scale-100 opacity-0"
      enterTo="transform scale-100 opacity-100"
      leave="transition duration-300 ease-out"
      leaveFrom="transform scale-300 opacity-100"
      leaveTo="transform scale-100 opacity-0"
      className={"fixed z-[11] top-0 left-0 w-full h-full"}
      show={open}
    >
      <div
        className="fixed inset-0 bg-black/10 z-[1]"
        onClick={() => onCross()}
        aria-hidden="true"
      />
      <Transition.Child
        enter="transition duration-300 ease-out"
        enterFrom="transform scale-95 opacity-0"
        enterTo="transform scale-100 opacity-100"
        leave="transition duration-300 ease-out"
        leaveFrom="transform scale-300 opacity-100"
        leaveTo="transform scale-95 opacity-0"
        className={`bg-white z-[2] flex flex-col top-[100px] max-h-[300px] fixed w-[40vw] left-[50%] transform -translate-x-1/2 rounded-lg p-4`}
      >
        <div className="flex flex-row justify-between ">
          <p className="flex text-2xl font-semibold">{title}</p>
          <div className="flex flex-row justify-end gap-4">
            <ReactSVG
              src="/icons/print.svg"
              className="w-6 pt-1.5 pr-2"
              style={{ transform: "scale(1.3)", transformOrigin: "center" }}
            />

            <button
              type="button"
              className="flex items-center justify-center p-1 transition-all rounded-full max-w-8 cursor-pointer right-4 top-3 bg-blue-200 hover:bg-REELTeal hover:text-white text-teal-300"
              onClick={() => toggleViewer()}
            >
              <span className="sr-only">Close panel</span>
              <XMarkIcon className="w-5 h-5" aria-hidden="true" />
            </button>
          </div>
        </div>
        <div className=" my-auto py-4">
          {showViewer && (
            <PDFViewer showToolbar={false} style={{ padding:0, width: "100%", height: "70vh" }}>
              {component()}
            </PDFViewer>
          )}
        </div>
      </Transition.Child>
    </Transition>
  );
};

export default PdfDialog;
